module.exports = "/fonts/halona-logotype-l-e8b1f0843f468297e2edcc8c30d24fbd.svg";